// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9ccd398d","703":"608343c4","787":"5f912a1f"}[chunkId] + ".chunk.js";
};